export default __webpack_public_path__ + "static/media/calender-new.12b62362.svg";